const config = {
  Panel_interview: 'Panel interview',
  number_team: 'No. of Interviews：',
  interview_location: 'Location：',
  interview_time: 'Interview Time：',
  interview_date: 'Interview Date：',
  Rated_items: 'Interview Items',
  done: 'Completed：',
  details: 'Student Information',
  Sname: 'Name of Student：',
  application_id: 'Application No：',
  sex: 'Gender：',
  man: 'M',
  girl: 'F',
  Birthdate: 'Date of Birth：',
  Parent_material: 'Parents Information',
  name: 'Name：',
  career: 'Occupation：',
  telephone: 'Mobile Tel：',
  Native_graduate: 'Native graduate:',
  FATHER: 'Father',
  MOTHER: 'Mother',
  GUARDIAN: 'GuardIan',
  Yes: 'Yes',
  no: 'No',
  Writing_evaluation: 'Remarks / Comments',
  stockpile: 'SAVE',
  candidate: 'Remarks / Comments',
  interview_system: 'Interview system',
  interview_panel: 'interview pane',
  attendees: 'Show only attendees',
  score: 'score',
  select: 'You have not select any interview items',
  grade: 'grade',
  // 假數據內容
  item_one: 'Ask the children to fold up the blocks.',
  item_two: 'Ask the children to string the beads together.',
  item_three: 'See if your child knows how to put together a puzzle.',
  item_four:
    'Let the children choose their own books or toys and observe whether they are self-motivated and active in the process of playing. ',
  item_five:
    'In group work, observe how well you get along with others, how polite you are, how overbearing or shy you are. ',
  total: 'No. of Interviews：',
  ApplicationNo: 'Application No',
  InterviewScores: 'Interview Scores',
  employee: 'Is the {{value}} a PLK employee?',
  graduate: 'Is the {{value}} a PLK graduate?',
  WorkPlace: 'Work Place',
  FirstLanguage: 'First Language',
  Telephonenight: 'Telephone (night)',
  SingleMode: 'Single Mode',
  select_task: 'Select task',
  date: 'Date',
  teacher: 'Teacher',
  no_data: 'No Information',
  total_score: 'Total score',
  go_back_list: 'Go Back list',
  NameEnglish: 'Name in English：',
  Parent: 'Parent',
  tit: 'Tips',
  determine: 'Determine',
  cancel: 'cancel',
  resetscore: 'Are you sure you want to reset the score?',
  Resetsucceeded: 'Reset succeeded',
  Resetfailed: 'Reset failed',
  InterviewNo: 'Interview No. ：',
  studying: 'Brother(s) or sister(s) studying?：',
  ChangeRole: 'All roles',
  _ChangeRole: 'Change role',
  no_record: 'No record'
};

export default config;
